var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmarkWithBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 10C18.3334 14.6021 14.6022 18.3334 10.0001 18.3334C5.398 18.3334 1.66675 14.6021 1.66675 10C1.66675 5.39794 5.398 1.66669 10.0001 1.66669C14.6022 1.66669 18.3334 5.39794 18.3334 10Z",
    fill: "#D2F9E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4108 6.07751L8.75664 11.7383L6.42247 9.41085L5.24414 10.5892L8.75831 14.095L15.5896 7.25585L14.4108 6.07751Z",
    fill: "#138646"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkWithBg);
export default __webpack_public_path__ + "static/media/checkmark-with-bg.1ef9bfd89ae84b2302779b48d3365189.svg";
export { ForwardRef as ReactComponent };